module.exports = __webpack_public_path__ + "static/media/ic_arrow_drop_down.733c8ba9.svg";